import React, { Fragment, useEffect, useState } from "react";
import { FnBlock_UI } from 'components/BlockUI';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { ColumnProps } from "components/TableUI/TableUI";
import { BtnAddTable, BtnCancel, BtnDeleteTable, BtnEditTable, BtnSearchTable, BtnViewTable } from "components/Button";
import { Chip, Grid } from "@mui/material";
import TableUI from "components/TableUI";
import { useLocation, useNavigate } from "react-router-dom";
import { SelectMultipleFormItem, TextBoxForm } from "components/Input";

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { OptionsStatus, undefinedOrNull } from 'utilities/Function';
import { DeleteUser, GetDataAll, LoadDataToTable } from "./CallAPI";
import { SwAlert } from "components";
import { AlertMsg, AlertTitle } from 'config/AlertMsgConfig';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#0053b5", //theme.palette.common.black,
        color: theme.palette.common.white,
        border: '1px solid rgba(224, 224, 224, 1) !important',
        padding: '10px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: '8px',
        border: '1px solid rgba(224, 224, 224, 1) !important',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // border: '1px solid rgba(224, 224, 224, 1) !important',
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function AdminUser_List() {

    //#region State
    const navigate = useNavigate();
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const [IsPemission, SetIsPemission] = useState(false);  //True แก้ไข / False ดู

    const [Loading, SetLoading] = useState(false);
    const [ArrRoleType, SetArrRoleType] = useState([{ value: "1", label: "ผู้ดูแลระบบ", }, { value: "2", label: "ฝ่ายทรัพยากรบุคคล", }, { value: "3", label: "ฝ่ายสรรหาบุคลากร", }] as any);
    // const ArrStatus = [{ value: true, label: "ใช้งาน", }, { value: false, label: "ไม่ใช้งาน", }];

    const [ArrDataRow, SetArrDataRow] = useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    //#endregion

    //#region Form YUP
    const objSchema = yup.object().shape({
        sUserName: yupFormSchemas.string("ชื่อ-นามสกุล", { required: false }),
        sRoleType: yupFormSchemas.string("ตำแหน่ง", { required: false }),
        sStatus: yupFormSchemas.string("สถานะ", { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(objSchema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError",
    });
    //#endregion

    //#region Column
    const ColumnData: ColumnProps[] = [
        {
            id: "nNo",
            name: "ลำดับ",
            width: "5%",
            cellAlign: "center"
        },
        {
            id: "sUserName",
            name: "ชื่อ - นามสกุล",
            width: "40%",
            cellAlign: "center"
        },
        {
            id: "sRoleType",
            name: "ตำแหน่ง",
            width: "20%",
            cellAlign: "center"
        },
        {
            id: "sStatus",
            name: "สถานะ",
            width: "15%",
            cellAlign: "center",
            renderCell: (item) => {
                return (
                    <>
                        {item.sStatus === "ใช้งาน" && (
                            <Chip
                                size="small"
                                // icon={<CheckCircle style={{ color: "#50cd89" }} />}
                                label={"ใช้งาน"}
                                style={{
                                    color: "#50cd89",
                                    backgroundColor: "#e8fff3",
                                    margin: "0.2rem",
                                    fontSize: "1.05rem"
                                }}
                            />
                        )}
                        {item.sStatus === "ไม่ใช้งาน" && (
                            <Chip
                                // icon={<Cancel style={{ color: "#f1416c" }} />}
                                label={"ไม่ใช้งาน"}
                                size="small"
                                style={{
                                    color: "#f1416c",
                                    backgroundColor: "#fff5f8",
                                    margin: "0.2rem",
                                    fontSize: "1.05rem"
                                }}
                            />
                        )}
                    </>
                )
            }
        },
        {
            id: "sUpdateDate",
            name: "วันที่แก้ไข",
            width: "15%",
            cellAlign: "center"
        },
        {
            id: "sUpdateUserName",
            name: "ผู้แก้ไข",
            width: "15%",
            cellAlign: "center"
        },
        {
            id: "Button",
            name: "",
            width: "8%",
            cellAlign: "center",
            renderCell: (item) => {
                return (
                    <div style={{ display: "inline-flex", textAlign: "center" }}>
                        <BtnEditTable title="แก้ไขข้อมูล" onClick={() => onEdit(item.nID, "Edit")} />
                        <BtnDeleteTable title="ลบข้อมูล" style={{ marginLeft: "5px" }} onClick={() => onDelete(item.nID)} />
                    </div>
                )               
            }
        }
    ];

    //#endregion

    //#region FN
    useEffect(() => {
        onGetDataAll();
        onSearch();
    }, [])

    const onGetDataAll = () => {
        GetDataAll((result) => {
            console.log("GetDataAll > List Admin", result);
            SetArrRoleType(result.ArrRoleType ?? []);

            //สิทธิ์ User ต้องเป็น Admin เท่านั้นถึงมีสิทธิ์เห็นเมนูนี้ ถ้าไม่ใช่ไม่มีสิทธิ์เห็น
            SetIsPemission(result.IsPemission); //True แก้ไข / False ดู
        });
    }

    const onSearch = () => {
        let obj = {
            sUserName: (form.getValues("sUserName") === "" || form.getValues("sUserName") === null) ? null : form.getValues("sUserName"),
            nRoleTypeID: form.getValues("sRoleType") != null ? form.getValues("sRoleType").map(m=> (+m)) : [],
            IsStatus: form.getValues("sStatus") ?? [],
        }
        LoadDataToTable(obj, (result) => {
            SetArrDataRow(result ?? []);
        }, BlockUI, UnBlockUI);
    }

    const onEdit = (nID, sMode) => {
        let sUrl = "/AdminUser_From";     
        navigate(sUrl, { state: { nID: nID, sMode: sMode } }); //sMode (Add/Edit/View)
    }

    const onDelete = (nID) => {
        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.ConfirmDelete, () => {
            DeleteUser({ nID: nID }, () => {
                SwAlert.Success(AlertTitle.Success, AlertMsg.DeleteComplete, () => { onSearch(); });
            }, BlockUI, UnBlockUI);
        });
    }
    //#endregion

    return (
        <FormProvider {...form}>
            <Grid item container direction="row" xs={12} md={12} spacing={2} marginBottom={1}>
                <Grid item container direction="row" spacing={2} justifyContent="start" alignItems="start">
                    {/* <Grid item xs={12} md={2}>
                        <BtnAddTable onClick={() => navigate(`/AdminUser_From`, { state: { sID: 0, sMode: "Add" } })} />
                    </Grid> */}
                    <Grid item xs={12} md={12} container direction="row" spacing={2} justifyContent="right" alignItems="start">
                        <Grid item xs={12} md={4}>
                            <TextBoxForm
                                name='sUserName'
                                label='ชื่อ-นามสกุล'
                                fullWidth
                                maxLength={150}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={3.5}>
                            <SelectMultipleFormItem
                                name='sRoleType'
                                label='ตำแหน่ง'
                                fullWidth
                                options={ArrRoleType}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectMultipleFormItem
                                name='sStatus'
                                label='สถานะ'
                                fullWidth
                                options={OptionsStatus}
                                disabled={false}
                            />
                        </Grid>
                        <Grid item >
                            <BtnSearchTable onClick={() => {onSearch();}} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12}>              
                    <Paper sx={{ width: '100%' }}>
                        <TableContainer sx={{ maxHeight: 600 }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <StyledTableRow>
                                        {ColumnData.map((column) => (
                                            <StyledTableCell
                                                key={column.id}
                                                align={column.cellAlign}
                                                style={{ minWidth: column.width }}
                                            >
                                                <>
                                                    {column?.id === "Button" ? 
                                                        <div style={{textAlign:"center", display: (!IsPemission ? "none" : "")}}>
                                                            <BtnAddTable onClick={() => navigate(`/AdminUser_From`, { state: { sID: 0, sMode: "Add" } })} />
                                                        </div>
                                                        :
                                                        <Grid item>{column?.name}</Grid>                                                        
                                                    }
                                                </>
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {(ArrDataRow ?? []).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                        return (
                                            <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.nID}>
                                                {ColumnData.map((column) => {
                                                    const value = row[column.id];
                                                    return (
                                                        <>
                                                            {column.id === "Button" ?
                                                                <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                    {IsPemission ? 
                                                                        <div style={{ textAlign: "center", display: "inline-flex"}}>
                                                                            <BtnEditTable title="แก้ไขข้อมูล" onClick={() => onEdit(row.nID, "Edit")} />
                                                                            <BtnDeleteTable title="ลบข้อมูล" style={{ marginLeft: "5px" }} onClick={() => onDelete(row.nID)} />
                                                                        </div>
                                                                        :
                                                                        <div style={{ textAlign: "center", display: "inline-flex"}}>
                                                                            <BtnViewTable title="ดูข้อมูล" style={{ marginLeft: "5px" }} onClick={() => onEdit(row.nID, "View")} />
                                                                        </div>
                                                                    }
                                                                </StyledTableCell>
                                                                :
                                                                (column.id === "sStatus" ?
                                                                    <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                        <>
                                                                            {row.sStatus === "ใช้งาน" && (
                                                                                <Chip
                                                                                    size="small"
                                                                                    label={"ใช้งาน"}
                                                                                    style={{
                                                                                        color: "#50cd89",
                                                                                        backgroundColor: "#e8fff3",
                                                                                        margin: "0.2rem",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            {row.sStatus === "ไม่ใช้งาน" && (
                                                                                <Chip
                                                                                    label={"ไม่ใช้งาน"}
                                                                                    size="small"
                                                                                    style={{
                                                                                        color: "#f1416c",
                                                                                        backgroundColor: "#fff5f8",
                                                                                        margin: "0.2rem",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </>
                                                                    </StyledTableCell>
                                                                    :
                                                                    <StyledTableCell key={column.id} align={column.cellAlign}>
                                                                        {value}
                                                                    </StyledTableCell>
                                                                )
                                                            }
                                                        </>
                                                    );
                                                })}
                                            </StyledTableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={(ArrDataRow ?? []).length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </FormProvider>
    )
}